import React from "react";
import "./EditUser.css";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../Context/useAuth";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import { updateProfileAPI } from "../../Services/AuthService";
import { toast } from "react-toastify";

type Props = {};

type EditUserProfileFormsInputs = {
  username: string;
  first_name: string;
  last_name: string;
  location: string;
  rider_type: string;
};

const profileValidation = Yup.object().shape({
  username: Yup.string().required("Username is required"),
  first_name: Yup.string().required("Email is required"),
  last_name: Yup.string().required("last name is required"),
  location: Yup.string().required("Location is required"),
  rider_type: Yup.string().required("Rider type is required")
});


const EditUser = (props: Props) => {
  const { user, updateUser } = useAuth();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { 
    register,
    handleSubmit } = useForm<EditUserProfileFormsInputs>({
    resolver: yupResolver(profileValidation),
  });

  const handleEditProfile = (form: EditUserProfileFormsInputs) => {
    if (user){
      updateProfileAPI(user?.id, form.username, user.email, form.first_name , form.last_name, 
        form.rider_type, form.location, user.profile_pic_url)
        .then((res) => {
          if (res){
            updateUser(res.data);
            handleClose();
          }
        })
        .catch((e) => {
          toast.warning(e);
        });
    }
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Edit Profile
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit your profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleEditProfile)}>
            <div className="mb-3">
              <label htmlFor="username">Username</label>
              <Form.Control id="username" {...register("username")} type="text" defaultValue= {user?.username} />
            </div>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="first_name">First name</Form.Label>
              <Form.Control id="first_name" {...register("first_name")} type="text" defaultValue= {user?.first_name} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="last_name">Last Name</Form.Label>
              <Form.Control id="last_name" {...register("last_name")} type="text" defaultValue= {user?.last_name} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="rider_type">Rider type</Form.Label>
              <Form.Control id="rider_type" {...register("rider_type")} type="text" defaultValue= {user?.rider_type} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label htmlFor="location">Location</Form.Label>
              <Form.Control id="location" {...register("location")} type="text" defaultValue= {user?.location} />
            </Form.Group>
            <div className="d-grid">
              <Button type="submit" variant="primary">
                Save
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditUser;
